"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.materialRevision = materialRevision;
exports.preloadBalloonMaterials = preloadBalloonMaterials;
exports.drawBalloonMaterial = drawBalloonMaterial;
const surfaces = {
    latex: { image: null, revision: 0, pending: null },
    fabric: { image: null, revision: 0, pending: null }
};
function materialRevision(material) { return surfaces[material].revision; }
function load(material) {
    const surface = surfaces[material];
    if (surface.pending)
        return surface.pending;
    const image = new Image();
    image.src = `/textures/${material}-surface.png`;
    surface.pending = image.decode().then(() => {
        surface.image = image;
        surface.revision++;
    }).catch(error => { surface.pending = null; throw error; });
    return surface.pending;
}
async function preloadBalloonMaterials() {
    const results = await Promise.allSettled([load('latex'), load('fabric')]);
    for (const result of results)
        if (result.status === 'rejected')
            console.warn('Balloon material failed:', result.reason);
}
/** Composite into the cached sprite only; the caller supplies the silhouette clip. */
function drawBalloonMaterial(ctx, material, r) {
    const image = surfaces[material].image;
    if (!image)
        return;
    ctx.save();
    ctx.globalCompositeOperation = material === 'fabric' ? 'multiply' : 'soft-light';
    ctx.globalAlpha = material === 'fabric' ? 0.32 : 0.3;
    ctx.drawImage(image, -r, -r, r * 2, r * (material === 'fabric' ? 2.2 : 2));
    ctx.restore();
}
//# sourceMappingURL=balloonMaterials.js.map